import Layout from '../views/layout/Layout'

export default {
  path: '/creative',
  component: Layout,
  redirect: 'noredirect',
  name: 'creative',
  hidden: true,
  meta: {
    title: '创意方向模板',
    elicon: 'el-icon-mobile-phone',
    roles: [],
  },
  children: [
    // 创意方向管理配置
    {
      path: 'template/:templateId(\\d+)',
      name: 'creative.template',
      component: () => import('@/views/creative/template/index.vue'),
      meta: {
        title: '模板配置',
        // dmaker.template.save playable 设计拥有的 key，可修改模板配置
        // dmaker.template.preview playable 开发拥有的 key，可预览模板配置
        roles: ['dmaker.template.save', 'dmaker.template.preview'],
      },
    },
    // 试玩模板管理配置
    {
      path: 'common-template/:templateId(\\d+)/skin/:skinId(\\d+)',
      name: 'creative.common-template',
      component: () => import('@/views/creative/template/index.vue'),
      meta: {
        title: '模板配置',
        roles: ['gmaker.template.save'],
      },
    },
  ],
}
